import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Stack,
  Select,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";

// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdUpdate,
  MdDelete,
  MdWarning,
  MdCreate,
} from "react-icons/md";
export default function BranchTable(props) {
  // custom variable

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputBranchID, setBranchID] = useState();
  const [inputBranchName, setBranchName] = useState();
  const [selectedRow, setSelectedRow] = useState();
  const [selectedOptionsRole, setSelectedOptionsRole] = useState([]);
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  // ref variable
  const skipPageResetRef = React.useRef();
  const cancelRef = React.useRef();
  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const updateBranch = async (dataBranch) => {
    try {
      // console.log(dataBranch.row.cells[0].value);
      let response = await ApiService.client
        .put(
          `/branch/update`,
          { id: inputBranchID, name_branch: inputBranchName },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const createBranch = async () => {
    try {
      let response = await ApiService.client
        .post(
          `/branch/create`,
          {
            id: inputBranchID, name_branch: inputBranchName
          },
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deleteBranch = async (dataBranch) => {
    try {
      // console.log(dataBranch.row.cells[0].value);
      let response = await ApiService.client
        .delete(
          `/branch/delete/` + dataBranch.row.cells[0].value,
          await ApiService.options()
        )
        .then((response) => {
          window.location.reload();
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    try {
      const fetchData = async () => {
        try {
          skipPageResetRef.current = true;
          let response = await ApiService.client.get(
            `/branch/GetAllDataBranchPaginationAndFiltering/${pageIndex + 1
            }/${dataPageSize}/all`,
            await ApiService.options()
          );
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.branches);
          skipPageResetRef.current = false;
        } catch (error) {
          if (error.response.status === 401) {
            // AuthService.logout().then(
            //   () => {
           //     console.log("Success Logout");
            //   },
            //   (error) => {
            //     (error.response &&
            //       error.response.data &&
            //       error.response.data.message) ||
            //       error.message ||
            //       error.toString();
            //   }
            // );
            // history.push("/auth/sign-in");
          }

          // console.log("error ni", error.response.status);
        }
      };
      fetchData();
    } catch (error) {
      if (error.response.status === 401) {
        // history.push("/auth/sign-in");
      }
      // console.log(error);
    }
  }, [pageIndex, dataPage, dataPageSize, pageSize]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  function setRow(data) {
    setSelectedRow(data);
    onOpen(true);
  }

  function setRowUpdate(data) {
    setSelectedRow(data);
    setBranchID(data.row.cells[0].value);
    setBranchName(data.row.cells[1].value);
    onOpen2(true);
  }

  function setRowDelete(data) {
    setSelectedRow(data);
    setBranchID(data.row.cells[0].value);
    setBranchName(data.row.cells[1].value);
    onOpen1(true);
  }

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Branch Management
        </Text>
        {/* <Menu /> */}
      </Flex>

      {/* Modal For Create Branch */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen3}
        onClose={onClose3}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Create Branch</ModalHeader>
          <ModalBody>
            <InputGroup mb={5}>
              <InputLeftAddon children="Branch ID" />
              <Input
                focusBorderColor="black"
                placeholder="Input Branch ID"
                borderRadius="16px"
                value={inputBranchID}
                onChange={(e) => setBranchID(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Branch Name" />
              <Input
                focusBorderColor="black"
                placeholder="Input Branch Name"
                borderRadius="16px"
                value={inputBranchName}
                onChange={(e) => setBranchName(e.target.value)}
              />
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose3}>
              Cancel
            </Button>
            <Button colorScheme="facebook" onClick={() => createBranch()}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal For Update Branch */}
      <Modal
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen2}
        onClose={onClose2}
      >
        <ModalOverlay
          bg="blackAlpha.300"
          backdropFilter="blur(10px) hue-rotate(0deg)"
        />
        <ModalContent>
          <ModalHeader>Update Branch</ModalHeader>
          <ModalBody>
          <InputGroup mb={5}>
              <InputLeftAddon children="Branch ID" />
              <Input
                focusBorderColor="black"
                placeholder="Input Branch ID"
                borderRadius="16px"
                value={inputBranchID}
                onChange={(e) => setBranchID(e.target.value)}
              />
            </InputGroup>
            <InputGroup mb={5}>
              <InputLeftAddon children="Branch Name" />
              <Input
                focusBorderColor="black"
                placeholder="Input Branch Name"
                borderRadius="16px"
                value={inputBranchName}
                onChange={(e) => setBranchName(e.target.value)}
              />
            </InputGroup>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose2}>
              Cancel
            </Button>
            <Button
              colorScheme="facebook"
              onClick={() => updateBranch(selectedRow)}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Alert For Delete Branch */}
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay
          bg="none"
          backdropFilter="auto"
          backdropInvert="100%"
        >
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Branch
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => deleteBranch(selectedRow)}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Stack
        px="20px"
        justify="space-between"
        mb="20px"
        align="center"
        spacing={4}
        direction="row"
      >
        <Button
          leftIcon={<MdCreate />}
          colorScheme="blue"
          size="md"
          borderRadius="lg"
          onClick={onOpen3}
        >
          Create
        </Button>
      </Stack>

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "ID") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BRANCH NAME") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }  else if (cell.column.Header === "UPDATE") {
                    data = (
                      <Button
                        leftIcon={<MdUpdate />}
                        colorScheme="teal"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowUpdate(cell)}
                      >
                        Update
                      </Button>
                    );
                  } else if (cell.column.Header === "DELETE") {
                    data = (
                      <Button
                        isDisabled={
                          cell.row.cells[3].value === true ? true : false
                        }
                        leftIcon={<MdDelete />}
                        colorScheme="red"
                        size="sm"
                        borderRadius="xl"
                        onClick={() => setRowDelete(cell)}
                      >
                        Delete
                      </Button>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
